"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { LoginMethodTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useInitGlobalState } from "@/hooks/initGlobalState";
import { useEffect } from "react";
import { deleteTokens } from "../functions/cookieOperations";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useAtom } from "jotai";
import { usePathname } from "next/navigation";

const InitGlobaleStateLeaf = () => {
  const { data } = useGetCompanyQuery();
  const pathname = usePathname();
  const [, setSignedIn] = useAtom(isSignedInAtom);
  useInitGlobalState();
  useEffect(() => {
    if (
      data?.result?.theme?.settings?.customer_login_methods ===
      LoginMethodTypes.none
    ) {
      deleteTokens();
      setSignedIn(false);
    }
  }, [data, pathname]);
  return <></>;
};

export default InitGlobaleStateLeaf;
